import * as React from 'react';

import { useInitRecommendations, useRecommendations } from './useRecommendations';
import { trackEntityTeaserShow } from './tracking';
import { useSelector } from 'react-redux';
import { selectIsIndexLandingType, selectLandingType } from '../../selectors/landingType';
import { useApplicationContext } from '../../utils/applicationContext';
import { EQueryParameters as ELandingType } from '../../repositories/feed-page/v2/mobile-site/get-recommendations';
import { RecommendationsListDesktopContainer } from './RecommendationsListDesktopContainer';
import { RecommendationsListMobileContainer } from './RecommendationsListMobileContainer';

export function RecommendationsListContainer() {
  const { config } = useApplicationContext();

  useInitRecommendations();

  const recommendationsControls = useRecommendations();
  const landingType = useSelector(selectLandingType);
  const showNewbuildingRecommendations = Boolean(
    useSelector(selectIsIndexLandingType) || config.get('NewbuildingRecommendations.ShowOnVerticals.Enabled'),
  );
  const isMainPage = landingType === ELandingType.MainPage;
  const infiniteScroll = landingType !== ELandingType.FlatRentForDay;
  const { isMobile } = recommendationsControls;

  const handleEntityTrackTeaserShow = React.useCallback(
    (offerId: number | null, position: number, contextToken?: string) => {
      if (!offerId) {
        return;
      }

      trackEntityTeaserShow({ offerId, position, contextToken }, isMobile);
    },
    [isMobile],
  );

  if (isMobile) {
    return (
      <RecommendationsListMobileContainer
        recommendationsControls={recommendationsControls}
        onTrack={handleEntityTrackTeaserShow}
        isMainPage={isMainPage}
        infiniteScroll={infiniteScroll}
      />
    );
  }

  return (
    <RecommendationsListDesktopContainer
      recommendationsControls={recommendationsControls}
      onTrack={handleEntityTrackTeaserShow}
      showNewbuildingRecommendations={showNewbuildingRecommendations}
    />
  );
}
